import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="transform-drawer" on the transform drawer form.
// Gates the drawer close on a successful server save: a 422 re-renders the drawer
// frame with errors (drawer stays open), so we only close on a 2xx response.
export default class extends Controller {
  submitEnd(event) {
    if (!event.detail.success) return

    const host = this.element.closest('[data-controller~="drawer-instance"]')
    if (!host) return

    const controller = this.application.getControllerForElementAndIdentifier(host, "drawer-instance")
    controller?.forceClose()
  }
}
